"use client";

import { create } from "zustand";

const STORAGE_KEY = "nimble_recent_searches";
const MAX_ITEMS = 3;

export interface RecentSearchesStore {
  recentSearches: readonly string[];
  addSearch: (term: string) => void;
}

export const getInitialSearches = (): readonly string[] => {
  if (typeof window === "undefined") return [];

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];

    const parsed: unknown = JSON.parse(stored);
    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter((item): item is string => typeof item === "string")
      .slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
};

const useRecentSearches = create<RecentSearchesStore>()((set) => ({
  recentSearches: getInitialSearches(),
  addSearch: (term: string) =>
    set((state) => {
      if (!term.trim()) return state;

      const filtered = state.recentSearches.filter(
        (item) => item.toLowerCase() !== term.toLowerCase(),
      );

      return { recentSearches: [term, ...filtered].slice(0, MAX_ITEMS) };
    }),
}));

useRecentSearches.subscribe((state) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state.recentSearches));
  }
});

export default useRecentSearches;
